import { useCurrencyAmountFormatter } from '@routable/shared';
import PropTypes from 'prop-types';
import React from 'react';

import { FeesChargedSeparatelyWarning } from 'complexComponents/tooltipTypes/sharedComponents';

import { Icon, IconNames } from 'components/icon';
import { TextAndIconsRelation } from 'components/relation';
import { TooltipMUIIcon } from 'components/tooltip';

import { CurrencyCode } from 'constants/currency';
import { colors, margin, sizes } from 'constants/styles';
import { TooltipPadding } from 'constants/tooltip';

const TransactionFeeRelation = ({ billingData, feeAmount }) => {
  const { formatCurrencyAmount } = useCurrencyAmountFormatter();

  if (!billingData) {
    return null;
  }

  const transactionFee = formatCurrencyAmount({ amount: feeAmount, currency: CurrencyCode.USD });

  return (
    <TextAndIconsRelation
      className="relation_transaction-fee"
      iconLeft={
        <Icon
          color={colors.colorAquaBoldHex}
          icon={IconNames.SMALL_PLUS}
          marginRight={margin.small}
          size={sizes.iconSizes.LARGE}
        />
      }
      iconRight={
        <TooltipMUIIcon
          icon={IconNames.INFO_SIGN}
          iconProps={{ size: sizes.iconSizes.LARGE }}
          tooltipProps={{
            className: 'relation--right-icon',
            arrow: true,
            padding: TooltipPadding.LARGE,
            title: <FeesChargedSeparatelyWarning />,
          }}
        />
      }
      text={`${transactionFee} - ${billingData.title}`}
    />
  );
};

TransactionFeeRelation.propTypes = {
  billingData: PropTypes.shape({ title: PropTypes.string.isRequired }),
  feeAmount: PropTypes.number.isRequired,
};

export default TransactionFeeRelation;
